<template>
  <interview-layout :touch-and-validate="touchAndValidate" :show-help-button="true">
    <div>
      <h1 class="px-4 fade-in-up-enter-active animation-slowest max-100 text-primary">Terugwerkende kracht</h1>
      <div class="d-flex flex-column flex-lg-row justify-content-center">
        <base-card inner-class="container-narrow w-100" color="alternate" :outer-padding="true">
          <base-form @submit="onSubmit">
            <!-- Extra uitleg -->
            <base-card class="mb-4" inner-class="small" color="secondary">
              <h6 class="mb-2">Wat is terugwerkende kracht?</h6>
              <checkmark-item icon="info-circle-fill">
                Als u tussen 25 april 2023 en 3 juni 2025 isolatiemaatregelen heeft uitgevoerd, kunt u mogelijk alsnog subsidie aanvragen.
              </checkmark-item>
            </base-card>

            <!-- Kortere vraag -->
            <base-input
                type="radiobuttons"
                :options="yesNoOptions"
                name="HasMeasuresForRetroactive"
                v-model:value="lead.twk.IntakeMeasuresExecuted"
                >
                Heeft u in deze periode isolatiemaatregelen uitgevoerd waarvoor u <strong>Subsidie Isolatie Nij Begun - terugwerkende kracht</strong> heeft aangevraagd, of waarvoor u deze subsidie nog wilt aanvragen?
            </base-input>
          </base-form>
        </base-card>
      </div>
      <button-row class="mt-2 flex-row-reverse">
        <base-button class="ms-auto" icon="bi-arrow-right" @click="onSubmit" :disabled="shouldDisableNext">Volgende</base-button>
        <base-button variant="minimal-secondary" icon="bi-arrow-left" icon-position="start" @click="onPrev">Terug</base-button>
      </button-row>
    </div>
  </interview-layout>
</template>

<script>
import InterviewLayout from "@/views/layouts/InterviewLayout.vue";
import BaseCard from "@/components/BaseCard.vue";
import BaseForm from "@/components/BaseForm.vue";
import BaseInput from "@/components/BaseInput.vue";
import BaseButton from "@/components/BaseButton.vue";
import ButtonRow from "@/components/ButtonRow.vue";
import CheckmarkItem from "@/components/CheckmarkItem.vue";
import { FlowService } from "@/services/FlowService";
import { useAllStores } from "@/helpers/UseAllStores";

export default {
  components: {
    InterviewLayout,
    BaseCard,
    BaseForm,
    BaseInput,
    BaseButton,
    ButtonRow,
    CheckmarkItem
  },
  setup() {
    return { ...useAllStores() };
  },
  data() {
    return {
      yesNoOptions: [
        { label: 'Ja', value: true },
        { label: 'Nee', value: false },
      ],
    };
  },
  computed: {
    hasAdviesAccess() {
      return FlowService.getAllowedSection(this.$route.query.section) === 'advies';
    },
    isInIntakeSection() {
      const viewKey = FlowService.getViewKeyFromName(this.$route.name);
      if (viewKey === null) return false;
      const view = FlowService.sequence[viewKey];
      return view.section === 'intake';
    },
    shouldDisableNext() {
      if (this.hasAdviesAccess && this.isInIntakeSection) {
        return false;
      }
      return this.v$.twk.$invalid;
    }
  },
  mounted() {
    this.lead.markViewAsVisited(this.$route.name);
  },
  watch: {
    'lead.twk.IntakeMeasuresExecuted'(newValue) {
      console.log(newValue);
      if (!newValue && this.isInIntakeSection) {
        console.log('intakevalue reset');
        this.lead.isolatieplanCheck.Under10kCombined = null;
        this.lead.isolatieplanCheck.ProceedWithoutPlan = null;
        this.lead.isolatieplanCheck.IsolatieplanRequested = null;
        this.lead.isolatieplanCheck.IsolatieplanPlus = null;
      }
      
      // If in advies section and TWK is set to false, 
      // automatically set Under10kCombined to false (isolatieplan)
      // but don't reset the IsolatieplanRequested answer
      if (this.hasAdviesAccess && !this.isInIntakeSection) {
        if (newValue === true) {
          this.lead.isolatieplanCheck.Under10kCombined = false;
          this.lead.isolatieplanCheck.ProceedWithoutPlan = null;
        } else {
          this.lead.isolatieplanCheck.Under10kCombined = null;
          this.lead.isolatieplanCheck.ProceedWithoutPlan = false;
        }
      }
    },

    'lead.intakeCompletion.UserSituation'(newValue) {
      if (newValue === 'waiting_postcode') {
        this.lead.intakeCompletion.WillingToSpendBeforeSubsidy = null;
      }
    },

  },
  methods: {
    touchAndValidate() {
      if (this.hasAdviesAccess && this.isInIntakeSection) {
        return true;
      }

      this.v$.twk.$touch();
      return !this.v$.twk.$invalid;
    },
    onSubmit() {
      if (this.touchAndValidate()) {
        FlowService.pushNext(this);
      }
    },
    onPrev() {
      FlowService.pushPrev(this);
    },
  },
};
</script>

<style lang="scss">
</style>